import { UseQueryOptions, QueryKey } from "react-query";
import {
  GetSalesByTenderBetaReportQuery,
  GetSalesByTenderBetaReportQueryVariables,
  useGetSalesByTenderBetaReportQuery,
} from "../../generated/reporting";
import { SalesByTenderBetaData } from "../../types/reports";
import { formatSalesByTenderBeta } from "../../transformers/reports/formatSalesByTenderBeta";

export const useFetchSalesByTenderBeta = (
  variables: GetSalesByTenderBetaReportQueryVariables,
  options: UseQueryOptions<
    GetSalesByTenderBetaReportQuery,
    unknown,
    SalesByTenderBetaData,
    QueryKey
  > = {}
) =>
  useGetSalesByTenderBetaReportQuery(variables, {
    select: (report) => formatSalesByTenderBeta(report),
    keepPreviousData: true,
    staleTime: 60_000,
    ...options,
  });
